import { usePollKybPending } from './logic/usePollKybPeding';
import lottie from 'lottie-web';
import LottieAnimations from '@Assets/lottie/Lili_Kyb_Animation.json';
import { useEffect, useRef } from 'react';
import { FontWeight, Heading, HeadingVariant, Text } from '@lili/lili-frontend-common';
import { t } from 'i18next';

export const KybPendingPage = () => {
  const elLottieContainer = useRef<HTMLDivElement | null>(null);
  usePollKybPending();
  useEffect(() => {
    if (elLottieContainer.current) {
      lottie.loadAnimation({
        container: elLottieContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: LottieAnimations,
      });
    }
    return () => lottie.destroy();
  }, [elLottieContainer]);
  return (
    <div className='flex flex-col items-center justify-center w-[100vw] sm:w-[40vw] h-full bg-surface-primary-bw-00 py-[20px] px-[24px]'>
      <Heading
        fontWeight={FontWeight.MEDIUM}
        variant={HeadingVariant.H5}
        className='mb-[16px] text-center text-text-main-primary'>
        {t('pages.KYB_POLLING.title', "You're almost there!")}
      </Heading>
      <Text.H9 className='mb-[40px] w-full sm:max-w-[400px] text-text-main-primary text-center'>
        {t(
          'pages.KYB_POLLING.content',
          "We're reviewing your application - this will take less than a minute"
        )}
      </Text.H9>
      <div className='w-[80%] sm:w-[142px]' ref={elLottieContainer}></div>
    </div>
  );
};
